import { ChevronDown } from "lucide-react";
import React from "react";
import styles from "./FilterLayout.module.scss";

interface IFilterSectionProps {
	title: string;
	children: React.ReactNode;
	isCollapsible?: boolean;
	isOpen?: boolean;
	onToggle?: () => void;
}

export const FilterSection: React.FC<IFilterSectionProps> = ({
	title,
	children,
	isCollapsible = false,
	isOpen = true,
	onToggle,
}) => (
	<section className={styles.section}>
		{isCollapsible ? (
			<button type="button" className={styles.sectionToggle} data-is-open={isOpen} aria-expanded={isOpen} onClick={onToggle}>
				<span className={styles.sectionTitle}>{title}</span>
				<ChevronDown size={16} className={styles.sectionChevron} />
			</button>
		) : (
			<div className={styles.sectionTitle}>{title}</div>
		)}

		{!isCollapsible || isOpen ? <div className={styles.sectionBody}>{children}</div> : null}
	</section>
);
